import React, { FC } from "react";
import { FromThirdStepData } from "../../../Helpers/interfaces";
import { Input } from "../../Input/Input";
import { useForm, UseFormSetValue } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLabels } from "../../../Hooks/useLabels";
import { PhoneNumberValidator } from "../../../Validation/PhoneNumberValidator";
import { LoadingAnimation } from "../../../../LoadingAnimation/LoadingAnimation";
import { ModalLayout } from "../Modal";
import { Submit, SubmitType } from "../../Submit/Submit";
import { FieldStatus } from "../../../Helpers/FieldStatus";

interface PhoneNumberModalFormType {
	mobileNumber: number;
}

interface PhoneConfirmationModalProps {
	onSubmit: (bookingRequest: FromThirdStepData) => void;
	onClose: () => void;
	getFormData: () => FromThirdStepData;
	setValue: UseFormSetValue<FromThirdStepData>;
	isOpen: boolean;
	heading: string;
	description: string;
	inputLabel: string;
	buttonLabel: string;
	loading: boolean;
}

export const PhoneConfirmationModal: FC<PhoneConfirmationModalProps> = ({
	onSubmit,
	onClose,
	getFormData,
	setValue,
	isOpen,
	heading,
	description,
	inputLabel,
	buttonLabel,
	loading,
}) => {
	const { bookingLabels } = useLabels();

	const {
		handleSubmit,
		getValues,
		formState: { errors },
		register,
	} = useForm<PhoneNumberModalFormType>({
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: { mobileNumber: getFormData().mobileNumber },
		resolver: yupResolver(PhoneNumberValidator(bookingLabels!.bookingErrors)),
	});

	const createBooking = async ({ mobileNumber }: PhoneNumberModalFormType) => {
		setValue("mobileNumber", mobileNumber);
		onSubmit(getFormData());
	};

	return (
		<ModalLayout
			className="ConfirmationModal"
			onClose={onClose}
			isOpen={isOpen}
			heading={heading}
			bgColorVariant="blue"
		>
			<div
				className="ConfirmationModal__description"
				dangerouslySetInnerHTML={{
					__html: description,
				}}
			/>
			<form
				onSubmit={handleSubmit(createBooking)}
				className="ConfirmationModal__form"
			>
				<Input
					className="ConfirmationModal__input"
					name="mobileNumber"
					label={inputLabel}
					inputmode={"tel"}
					type="tel"
					getValues={getValues}
					error={errors.mobileNumber}
					register={register}
				/>
				<div className="ConfirmationModal__submit">
					<Submit
						type={SubmitType.submit}
						status={
							!!errors.mobileNumber || loading
								? FieldStatus.disabled
								: FieldStatus.active
						}
					>
						{loading ? <LoadingAnimation text={buttonLabel} /> : buttonLabel}
					</Submit>
				</div>
			</form>
		</ModalLayout>
	);
};
